import { combineReducers } from 'redux';

import samples from './samples';
import testSelection from './testSelection';
import primaryParameter from './primaryParameter';
import selectedSampleId from './selectedSampleId';
import secondaryParameter from './secondaryParameter';
import primaryParameterLevel from './primaryParameterLevel';

export default combineReducers({
  samples,
  testSelection,
  primaryParameter,
  selectedSampleId,
  secondaryParameter,
  primaryParameterLevel
});
